import { withInstall } from '../utils'
import _Sticky from './Sticky'

export const Sticky = withInstall(_Sticky)
export default Sticky
